export default {
  left_column: {
    title: 'Sprawdź saldo',
    description:
      'Wpisz kod karty podarunkowej, aby sprawdzić pozostałe saldo. Kod znajdziesz w pliku PDF karty podarunkowej.',
  },
  title: 'Sprawdź saldo karty podarunkowej',
  subtitle: 'Wprowadź kod karty podarunkowej, aby sprawdzić jej aktualne saldo',
  error: {
    title: 'Nie znaleziono karty podarunkowej!',
    description: 'Proszę wprowadzić prawidłowy kod karty podarunkowej.',
  },
  gift_card: {
    title: 'Karta podarunkowa została znaleziona!',
    balance: 'Saldo',
    value: 'Wartość',
    expires_at: 'Ważna do',
  },
  form: {
    code: {
      label: 'Kod karty podarunkowej',
    },
  },
  buttons: {
    check_balance: 'Sprawdź saldo',
  },
};
